import { Body, Heading, Icon } from '@assembly-js/design-system';

import { useSidebarUpdate } from 'src/features/sidebar/useSidebarUpdate';

export function SidebarUpdateCard() {
  const update = useSidebarUpdate();

  if (!update) {
    return null;
  }

  return (
    <button
      type="button"
      className="mb-3 w-full appearance-none hover:cursor-pointer bg-white border border-solid border-secondary-hover outline-hidden shadow-none rounded-lg p-2 py-1.5 flex flex-row items-center gap-2 hover:bg-secondary-hover"
      onClick={update.apply}
    >
      <div className="flex items-center justify-center rounded-md bg-secondary-hover p-1.5">
        <Icon icon="Repeat" className="h-4 w-4 text-secondary" />
      </div>
      <div className="flex flex-col w-full items-start">
        <Heading size="xs" className="text-black-heading">
          {update.title}
        </Heading>
        <Body className="text-secondary text-[10px]">{update.description}</Body>
      </div>
    </button>
  );
}
